// Supabase refuses a password log-in for an address whose confirmation link was
// never clicked. The newer client reports it as error.code; older responses
// only carry the message, so accept either.
export function isEmailNotConfirmed(error) {
  if (!error) return false;
  return error.code === 'email_not_confirmed' || /email not confirmed/i.test(error.message || '');
}
